
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[profileId]",
      function () {
        return require("private-next-pages/profile/[profileId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[profileId]"])
      });
    }
  